import { render, staticRenderFns } from "./AuthWrapper.vue?vue&type=template&id=767e4645&scoped=true&"
import script from "./AuthWrapper.vue?vue&type=script&lang=js&"
export * from "./AuthWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AuthWrapper.vue?vue&type=style&index=0&id=767e4645&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e4645",
  null
  
)

export default component.exports